import { forwardRef, useEffect, useImperativeHandle, useRef } from 'react'
import { useSelector } from 'react-redux';
import { GridTable } from './components/GridTable';

const Game = forwardRef(function Game({ onAnswer }, ref) {

  const gridRef = useRef();

  useImperativeHandle(ref, () => ({
    animateEntry: async () => {
      await gridRef.current.animateEntry();
    }
  }));

  const questions = useSelector((state) => state.game.questions);
  const numberScreens = questions.map(question => question.screenID).filter((value, index, self) => self.indexOf(value) === index).length;
  const currentQuestion = useSelector((state) => questions[state.game.currentIndex]);

  useEffect(() => {
    const passScreenAnimation = async () => {
      if (currentQuestion.screenID === 0) return;
      await gridRef.current.animateExit();
      await gridRef.current.animateEntry();
    }

    passScreenAnimation();

  }, [currentQuestion.screenID, numberScreens])

  return (
    <GridTable
      ref={gridRef}
      onAnswer={onAnswer}
      questions={questions}
      numberScreens={numberScreens}
    />
  )
})

export default Game